import {
  IonContent, IonImg, IonLabel, IonPage, IonSegment, IonSegmentButton, IonText,
} from '@ionic/react';
import { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import BackArrow from '@/assets/imgs/back-arrow.webp';
import LearningCard from '@/components/learning/LearningCard/LearningCard';
import { ROUTES_PATH } from '@/constants';
import {
  ArticleResponse,
  VideoItems,
  VideoResponse,
} from '@/interfaces/LearningInterface/LearningInterface';

import styles from './AllResourcesMobile.module.scss';

interface LocationState {
  route?: string;
}

export default function AllResourcesMobile() {
  const history = useHistory();
  const location = useLocation();

  const [articleList, setarticleList] = useState<ArticleResponse[]>([]);
  const [webinarList, setwebinarList] = useState<VideoItems[]>([]);

  const getArticlesFromApi = async () => {
    try {
      const response = await fetch(
        'https://pepperfinance.es/wp-json/wp/v2/posts/?per_page=20&categories=29&orderby=modified&order=desc',
      );
      const responseJson = await response.json();
      setarticleList(responseJson);
    } catch (error) {
      console.error(error);
    }
  };

  const getWebinarsFromApi = async () => {
    try {
      const response = await fetch(
        'https://www.googleapis.com/youtube/v3/playlistItems?key=AIzaSyAb8W--TEpkE3oqvwi7XOXGznIh7vHK3_g&playlistId=PLP9ms8Ry_5Oa7nnk6BTyC7N7tmEM2-ecy&part=id,snippet,contentDetails,status',
      );
      const responseJson: VideoResponse = await response.json();
      setwebinarList(responseJson.items);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getArticlesFromApi();
    getWebinarsFromApi();
    const state = location.state as LocationState;
    if (state.route === ROUTES_PATH.ARTICLE_ALL) {
      setSelectedSegment(1);
    }
  }, []);

  const [selectedSegment, setSelectedSegment] = useState(0);
  return (
    <IonPage className={styles.allResourcesPage}>
      <IonContent>
        <div className={styles.mobileHeader}>
          <div className={styles.headerTitle}>
            <IonImg
              src={BackArrow}
              className={styles.backArrow}
              onClick={() => {
                history.goBack();
              }}
            />

            <IonText className={styles.titleText}>
              {selectedSegment === 0 ? 'Webinars' : 'Artículos'}
            </IonText>
          </div>
          <div id="allresources-segments-container" className={styles.segmentsContainer}>
            <IonSegment
              mode="ios"
              value={selectedSegment}
              onIonChange={(event: any) => {
                setSelectedSegment(event.detail.value);
              }}
              className={styles.operationsDetailSegment}
            >
              <IonSegmentButton value={0}>
                <IonLabel>Webinars</IonLabel>
              </IonSegmentButton>
              <IonSegmentButton value={1}>
                <IonLabel>Artículos</IonLabel>
              </IonSegmentButton>
            </IonSegment>
          </div>
        </div>
        <div className={styles.contentWrapper}>
          <p className={styles.contentTitle}>Las últimas noticias y novedades para que estés siempre al día en nuestros servicios.</p>

          {selectedSegment === 0
          && webinarList.map((webinar: VideoItems, index) => (
            <LearningCard
              key={index}
              title={webinar?.snippet?.title}
              imgUrl={webinar?.snippet?.thumbnails?.medium?.url}
              smallTitle
              cardClick={() => {
                history.push({
                  pathname: `${ROUTES_PATH.WEBINAR_DETAIL}/${webinar?.id}`,
                  state: webinar,
                });
              }}
            />
          ))}

          {selectedSegment === 1
          && articleList.map((article: ArticleResponse, index) => (
            <LearningCard
              key={index}
              title={article.title?.rendered}
              subtitle={article.excerpt?.rendered}
              imgUrl={article.fimg_url}
              description={article.yoast_head_json.og_description}
              cardClick={() => {
                history.push({
                  pathname: `${ROUTES_PATH.ARTICLE_DETAIL}/${article.id}`,
                  state: article,
                });
              }}
            />
          ))}

        </div>
      </IonContent>
    </IonPage>
  );
}
